
module.exports.convertToAmPm = function (dateTimeString, timezone) { //2022-04-07T11:37:09.707Z
   
    if (!dateTimeString) return '';

    var timeString = dateTimeString.split("T")[1];
    var hours = timeString.split(":")[0];
    var minutes = timeString.split(":")[1];

    var ampm = hours >= 12 ? ' PM ' : ' AM ';
    ampm = ampm + timezone;

    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    return hours + ':' + minutes + ampm;
};



// WEBPACK FOOTER //
// ./js/Modules/Service/DateTimeUtil.js